import { render, staticRenderFns } from "./TextLeftIcon.vue?vue&type=template&id=83384c64&"
import script from "./TextLeftIcon.vue?vue&type=script&lang=js&"
export * from "./TextLeftIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports